import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import Logo from "@/components/Logo";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-appBg px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Link to="/"><Logo className="h-10" /></Link>
        </div>
        <div className="bg-white rounded-2xl p-8 ring-1 ring-slate-200 shadow-sm">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-14 h-14 rounded-full bg-[#E8F5E0] flex items-center justify-center mx-auto">
                <CheckCircle2 className="w-8 h-8 text-[#3F7A1F]" />
              </div>
              <h1 className="font-heading text-2xl font-bold text-[#1B3A6B] mt-5">{t("auth_page.forgot_sent_title")}</h1>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">{t("auth_page.forgot_sent_subtitle")}</p>
              <Link to="/login">
                <Button className="mt-6 w-full bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full font-semibold h-11" data-testid="forgot-back-login">
                  {t("auth_page.back_to_login")}
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold text-[#1B3A6B]">{t("auth_page.forgot_title")}</h1>
              <p className="mt-1 text-sm text-slate-500">{t("auth_page.forgot_subtitle")}</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label htmlFor="email">{t("auth_page.email")}</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" data-testid="forgot-email" />
                </div>
                <Button type="submit" disabled={busy} className="w-full bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full font-semibold h-11" data-testid="forgot-submit">
                  {busy ? t("auth_page.sending") : t("auth_page.send_reset_link")}
                </Button>
              </form>
              <p className="mt-6 text-center text-sm text-slate-500">
                <Link to="/login" className="text-[#1B3A6B] font-semibold">{t("auth_page.back_to_login")}</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
